function keys(object) {
  return Object.keys(object);
}

export { keys };
//# sourceMappingURL=keys.js.map
